import APIClient from '@/shared/http/clients/api'

const resourceName = 'AprCadastroBasicoTemplate'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllActivities = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllActivities/`, data, config)
const GetAllTypeRisks = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllTypeRisks/`, data, config)
const GetAllReasons = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllReasons/`, data, config)
const GetAllConsequences = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllConsequences/`, data, config)
const GetAllSpecialRisks = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllSpecialRisks/`, data, config)
const GetAllCourseNR = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllCourseNR/`, data, config)
const GetAllEquipamentoProtecaoIndividual = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllEquipamentoProtecaoIndividual/`, data, config)
const GetAllMedidasControle = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllMedidasControle/`, data, config)
const GetAllFonteGeradora = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllFonteGeradora/`, data, config)
const GetAllDescricaoAtividade = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllDescricaoAtividade/`, data, config)
const GetAllFerramentas = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllFerramentas/`, data, config)
const GetAllServiceStage = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllEtapaServico/`, data, config)

const EditTemplate = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditTemplate/`, data, config)
const AddTemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/AddTemplate/`, data, config)
const DeleteTemplate = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/DeleteTemplate/`, data, config)

const AprActivitiesRepository = {
  GetAllActivities,
  GetAllTypeRisks,
  GetAllReasons,
  GetAllConsequences,
  GetAllSpecialRisks,
  GetAllCourseNR,
  GetAllEquipamentoProtecaoIndividual,
  GetAllMedidasControle,
  GetAllFonteGeradora,
  GetAllDescricaoAtividade,
  GetAllFerramentas,
  EditTemplate,
  AddTemplate,
  DeleteTemplate,
  GetAllServiceStage
}

export default AprActivitiesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprActivities.js